/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface MediaControllerDownload$Params {
  prefix: string;
  name: string;
}

export function mediaControllerDownload(http: HttpClient, rootUrl: string, params: MediaControllerDownload$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, mediaControllerDownload.PATH, 'get');
  if (params) {
    rb.query('prefix', params.prefix, {});
    rb.query('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

mediaControllerDownload.PATH = '/file-manager/download';
